/* Étoiles (blocks/stars.liquid), option « Résumé au clic » : carte de résumé qui s'ouvre au clic,
   au survol ou au clavier. ES5, déclaré une seule fois (window.__etoilesResume). Aucune valeur Liquid ici. */
(function () {
  if (window.__etoilesResume) return;
  window.__etoilesResume = true;

  var survolPossible = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var MARGE = 12;
  var ouvert = null;
  var dernierClavier = 0;
  var minuteur = null;
  var ZONES = '[data-etres-zone], [data-etres-pop]';

  /* La section d'avis de la page : celle du thème ou celle d'une appli d'avis courante. */
  var CIBLES = '#avis, #reviews, #customer-reviews, [id^="crSection"], #judgeme_product_reviews, .jdgm-review-widget, #looxReviews, .loox-reviews-default, .okeReviews-reviews, .yotpo-main-widget, .stamped-main-widget, #shopify-product-reviews, [data-reviews-section]';

  function trouverCible() {
    var cible = document.getElementById('avis');
    if (!cible) {
      var liste = document.querySelectorAll(CIBLES);
      for (var i = 0; i < liste.length; i++) {
        if (!liste[i].closest('.etres') && !liste[i].closest('.product-information')) { cible = liste[i]; break; }
      }
    }
    if (cible && !cible.id) {
      var sec = cible.closest('.shopify-section');
      if (sec) cible = sec;
    }
    return cible;
  }

  /* Lien « Lire les avis » : vers la section d'avis de la page ; sans section, vers le lien de
     secours (data-secours, Paramètres du thème) ; sans les deux, masqué. */
  function verifierLiens() {
    var trouve = !!trouverCible();
    Array.prototype.forEach.call(document.querySelectorAll('[data-etres-lien]'), function (l) {
      var secours = l.getAttribute('data-secours');
      if (!trouve && secours) {
        l.setAttribute('href', secours.indexOf('#') < 0 ? secours + '#avis' : secours);
        l.hidden = false;
      } else {
        l.setAttribute('href', '#avis');
        l.hidden = !trouve;
      }
    });
  }

  function placer() {
    if (!ouvert) return;
    var b = ouvert.ancre.getBoundingClientRect();
    var pop = ouvert.pop;
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var horsEcran = b.bottom < 0 || b.top > vh;
    pop.style.visibility = horsEcran ? 'hidden' : '';
    if (horsEcran) {
      if (ouvert.mode === 'survol') fermer(false);
      return;
    }
    pop.style.left = '0px';
    pop.style.top = '0px';
    var largeur = pop.offsetWidth;
    var hauteur = pop.offsetHeight;
    var x = Math.max(MARGE, Math.min(b.left, vw - largeur - MARGE));
    var y = b.bottom + 8;
    var dessus = false;
    if (y + hauteur > vh - MARGE && b.top - 8 - hauteur >= MARGE) { y = b.top - 8 - hauteur; dessus = true; }
    /* Un ancêtre transformé déplace l'origine d'un élément fixe : on mesure et on corrige. */
    var r0 = pop.getBoundingClientRect();
    pop.style.left = Math.round(x - r0.left) + 'px';
    pop.style.top = Math.round(y - r0.top) + 'px';
    pop.classList.toggle('etres__pop--dessus', dessus);
    var br = ouvert.bouton.getBoundingClientRect();
    var fleche = Math.max(16, Math.min(br.left + br.width / 2 - x, largeur - 16));
    pop.style.setProperty('--etres-fleche', Math.round(fleche) + 'px');
  }

  /* La carte est « fixe » mais reste prise dans le plan d'empilement de ses ancêtres : un groupe
     isolé ou transformé la ferait passer SOUS le contenu posé après lui (images, cartes…).
     À l'ouverture, on remonte les ancêtres positionnés (ou éléments de flex/grille) au premier
     plan, et on rend leurs valeurs à la fermeture. On s'arrête à un ancêtre fixe ou collant. */
  function elever(racine) {
    var liste = [];
    for (var a = racine; a && a !== document.body && a !== document.documentElement; a = a.parentElement) {
      var cs = window.getComputedStyle(a);
      if (cs.position === 'fixed' || cs.position === 'sticky') break;
      var pere = a.parentElement ? window.getComputedStyle(a.parentElement).display : '';
      var itemFlex = /flex|grid/.test(pere);
      var posNeuve = '';
      if (cs.position === 'static' && !itemFlex) {
        var isole = cs.transform !== 'none' || cs.filter !== 'none' || cs.isolation === 'isolate' || parseFloat(cs.opacity) < 1;
        if (!isole) continue;
        posNeuve = 'relative';
      }
      liste.push([a, a.style.zIndex, a.style.position]);
      if (posNeuve) a.style.position = posNeuve;
      a.style.zIndex = '60';
    }
    return liste;
  }
  function abaisser(liste) {
    for (var i = 0; liste && i < liste.length; i++) {
      liste[i][0].style.zIndex = liste[i][1];
      liste[i][0].style.position = liste[i][2];
    }
  }

  function ouvrir(racine, mode) {
    if (!racine) return;
    var bouton = racine.querySelector('[data-etres-bouton]');
    var pop = racine.querySelector('[data-etres-pop]');
    if (!bouton || !pop) return;
    clearTimeout(minuteur);
    if (ouvert && ouvert.racine !== racine) fermer(false);
    if (ouvert && ouvert.racine === racine) {
      if (mode === 'epingle') ouvert.mode = 'epingle';
      return;
    }
    ouvert = { racine: racine, bouton: bouton, ancre: racine.querySelector('[data-etres-zone]') || bouton, pop: pop, mode: mode, eleves: elever(racine) };
    pop.hidden = false;
    bouton.setAttribute('aria-expanded', 'true');
    racine.classList.add('etres--ouvert');
    placer();
    requestAnimationFrame(function () { pop.classList.add('etres__pop--visible'); pop.classList.add('est-visible'); });
  }

  function fermer(rendreFocus) {
    clearTimeout(minuteur);
    if (!ouvert) return;
    var o = ouvert;
    ouvert = null;
    o.pop.classList.remove('etres__pop--visible');
    o.pop.classList.remove('est-visible');
    o.pop.hidden = true;
    o.bouton.setAttribute('aria-expanded', 'false');
    o.racine.classList.remove('etres--ouvert');
    abaisser(o.eleves);
    if (rendreFocus) o.bouton.focus();
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var lien = t.closest('a[data-etres-lien]');
    if (lien) {
      var cible = trouverCible();
      fermer(false);
      /* pas de section d'avis ici : le lien suit son adresse (lien de secours) */
      if (!cible) return;
      ev.preventDefault();
      var entete = document.querySelector('#header-component');
      var decalage = entete ? Math.round(entete.getBoundingClientRect().height) : 0;
      cible.style.scrollMarginTop = (decalage + 16) + 'px';
      var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' }); } catch (e) { cible.scrollIntoView(true); }
      return;
    }
    if (t.closest('[data-etres-fermer]')) { fermer(true); return; }
    var zone = t.closest('[data-etres-zone]');
    if (zone) {
      /* un clic dans l'éditeur ou sur les étoiles comme sur la flèche : ouvre / referme */
      var racine = zone.closest('[data-etres]');
      if (ouvert && ouvert.racine === racine && ouvert.mode === 'epingle') fermer(false);
      else ouvrir(racine, 'epingle');
      return;
    }
    if (ouvert && !t.closest('[data-etres-pop]')) fermer(false);
  });

  if (survolPossible) {
    document.addEventListener('mouseover', function (ev) {
      var zone = ev.target.closest && ev.target.closest(ZONES);
      if (!zone) return;
      var racine = zone.closest('[data-etres]');
      if (!racine) return;
      clearTimeout(minuteur);
      if (ouvert && ouvert.racine === racine) return;
      minuteur = setTimeout(function () { ouvrir(racine, 'survol'); }, 120);
    });
    document.addEventListener('mouseout', function (ev) {
      var zone = ev.target.closest && ev.target.closest(ZONES);
      if (!zone) return;
      var vers = ev.relatedTarget;
      if (vers && vers.closest && vers.closest(ZONES) && vers.closest('[data-etres]') === zone.closest('[data-etres]')) return;
      clearTimeout(minuteur);
      if (ouvert && ouvert.mode === 'survol') minuteur = setTimeout(function () { fermer(false); }, 220);
    });
  }

  /* Clavier : la carte s'ouvre quand la flèche reçoit le focus au clavier. */
  document.addEventListener('focusin', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (t.matches && t.matches('[data-etres-bouton]')) {
      if (Date.now() - dernierClavier < 800) ouvrir(t.closest('[data-etres]'), 'focus');
      return;
    }
    if (ouvert && !ouvert.racine.contains(t)) fermer(false);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Tab') dernierClavier = Date.now();
    if ((ev.key !== 'Escape' && ev.key !== 'Esc') || !ouvert) return;
    fermer(ouvert.racine.contains(document.activeElement));
  });

  window.addEventListener('resize', placer);
  document.addEventListener('scroll', function () { if (ouvert) placer(); }, true);

  /* Éditeur : sélectionner le bloc ouvre sa carte, le quitter la referme. */
  document.addEventListener('shopify:block:select', function (ev) {
    var t = ev.target;
    var r = t && t.closest ? t.closest('[data-etres]') : null;
    if (!r && t && t.querySelector) r = t.querySelector('[data-etres]');
    if (r) ouvrir(r, 'epingle');
  });
  document.addEventListener('shopify:block:deselect', function () { fermer(false); });
  document.addEventListener('shopify:section:load', function () { fermer(false); verifierLiens(); });

  if (document.readyState === 'complete') verifierLiens();
  else window.addEventListener('load', verifierLiens);
})();
